import { FC, ReactNode } from "react";
import { Box, useTheme, Typography } from "@mui/material";
import { Outlet, useLocation } from "react-router-dom";
import { styled } from "@mui/material/styles";
import Header from "./Header";
import Sidebar from "./Sidebar";

interface SidebarLayoutProps {
  children?: ReactNode;
}

const HeaderBlock = styled(Box)(
  ({ theme }) => `
   position: -webkit-sticky;
   position: sticky;
   top: 0;
   z-index: 1000;
   background: ${theme.header.background};
   box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
`
);

const FooterBlock = styled(Box)(
  () => `
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    background-color: #F9F8F8;
    color: #2C2B2B;
    text-align: center;
    padding-top: 16px;
    padding-bottom: 16px;
`
);

const ContentBlock = styled(Box)(() => ({
  height: "max-content",
  padding: "20px 20px 60px 20px",
}));

const SidebarLayout: FC<SidebarLayoutProps> = () => {
  const theme = useTheme();
  const location = useLocation();

  const hideSidebar = location.pathname === "/dashboard";

  return (
    <Box>
      {!hideSidebar && <Sidebar />}
      <Box
        sx={{
          [theme.breakpoints.up("lg")]: {
            ml: hideSidebar ? 0 : `${theme.sidebar.width}`,
          },
        }}
      >
        <HeaderBlock display="block">
          <Header />
        </HeaderBlock>
        <ContentBlock display="block">
          <Outlet />
        </ContentBlock>
        <FooterBlock>
          <Typography variant="body2">
            Copyright © {new Date().getFullYear()}{" "}
            <a href="https://www.snpspoothotta.org/" target="_blank" rel="noopener noreferrer">
              SNPS
            </a>
            . All rights reserved.
          </Typography>
        </FooterBlock>
      </Box>
    </Box>
  );
};

export default SidebarLayout;
